var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main page-inside payment-result-page"},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"section hero-section"},[_c('div',{staticClass:"page-inside-top"},[_c('div',{staticClass:"wrapper"},[_c('div',{class:[
              'title',
              'big',
              { 'error-title': _vm.status === 'failure', success: _vm.status === 'success' },
            ]},[_vm._v(" "+_vm._s(_vm.getTitle)+" ")]),_c('div',{class:['title', { 'error-desc': _vm.status === 'failure' }]},[_vm._v(" "+_vm._s(_vm.getDescription)+" ")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }